import find from 'lodash/find'

const tabKeys = ['teacher-tab', 'student-tab', 'course-tab']

export type TabKeyT = 'teacher-tab' | 'student-tab' | 'course-tab'

export function parseTab(tabPath: string): TabKeyT | undefined | null {
  return find(tabKeys, value => value === tabPath) as TabKeyT
}
